<template>
	<router-view></router-view>
</template>

<script>

export default {
	name: 'laundry',
};
</script>



// WEBPACK FOOTER //
// Laundry.vue?351a7310